export const configUkmetDh = {
  "timelist": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_UKMO_UM/index.json",
    "retain": true,
    "cache": false,
    "cache_busting": true,
    "update_interval": 60
  },
  "data": {
    "Type": "GeoTiff",
    "name": "UKMET_MAP",
    "url": "%wrap_url%/WX_UKMO_UM/%element%/%level%/%basetime%/%validtime%.tiff?type=map",
    "cache": true,
    "download_max": 32,
    "Grid": {
      "Width": 288,
      "Height": 145,
      "LatBase": 90.0,
      "LonBase": 0.0,
      "LatInterval": 1.25,
      "LonInterval": 1.25
    }
  }
};

export const configUkmetSpeedDirectionController = {
  "Controller": {
    "Name": "SpeedDirectionConverter",
    "UElement": "UGRD",
    "VElement": "VGRD"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configUkmetDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configUkmetDh
    }
  }
};

export const configUkmetUpConversionController = {
  "Controller": {
    "Name": "UpConversionFilter",
    "peak_filtering": true,
    "MaxScale": 4
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configUkmetDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configUkmetDh
    }
  }
}

export const configUkmetIcingProbController = {
  "Controller": {
    "Name": "IcingProbability",
    "TMPElement": "TMP",
    "RHElement": "RH"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configUkmetDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configUkmetDh
    }}
}

export const configUkmetLayerWindArrow = {
  "Name": "GPVWindArrow",
  "Renderer": "WindArrow",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "color": "rgb(156,97,44)"
      }
    }
  }
};

export const configUkmetLayerStreamLine = {
  "Name" : "StreamLine",
  "Renderer" : "StreamLine",
  "Attributes" : {
    "data_scale" : 1.94384,
    // "min" : "1.0,     流線の生成を行う最低速度（デフォルト1.0）",
    // "scale" : "0.01,  UV値から緯度経度距離に変換する調整係数。大きくすると流線の点間隔が荒くなる。（デフォルト0.01）",
    // "times" : "80,     一本の流線を生成するシミュレーション回数＝流線が何本の折れ線で構成されるか（デフォルト80）",
    // "lines" : "10000,  生成する流線の数（デフォルト10000）",
    // "duration" : "10,  一本の流線のアニメーション時間（秒：デフォルト10）",
    // "separation" : "1, 一本の流線をいくつの部分に分割して表示するか（デフォルト1）（整数）",
    // "display" : "0.5,  一本の流線全体の中で、表示されている部分の比率（デフォルト0.5）",
    "min" : 1.0,
    "scale" : 0.01,
    "times" : 40,
    "lines" : 5000,
    "duration" : 3,
    "separation" : 1,
    "display" : 0.3,
    "style" : {
      "default" : {
        "palette" : [
          {
            "value" : 0.0,
            "color" : "rgba(182, 221, 245, 0.8)"
          }
        ]
      }
    }
  }
}

export const configUkmetLayerIsotach = {
  "Name" : "Isotach",
  "Renderer" : "Contour",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "contour": [
          {
            "base":20,
            "interval":20,
            "num": 4,
            "lineWidth": 1,
            "strokeStyle": "rgba(22, 176, 254, 1)",
            "textColor": "rgba(22, 176, 254, 1)",
            "fontSize": 14
          },
          {
            "base":100,
            "interval":20,
            "num": 3,
            "label_interval": 250,
            "lineWidth": 1,
            "strokeStyle": "rgba(144, 238, 144, 1)",
            "textColor": "rgba(11, 141, 11, 1)",
            "fontSize": 14
          },
          {
            "base":160,
            "interval":20,
            "num": 2,
            "label_interval": 125,
            "lineWidth": 1,
            "strokeStyle": "rgba(244, 150, 44, 1)",
            "textColor": "rgba(153, 87, 12, 1)",
            "fontSize": 14,
          }
        ]
      }
    }
  }
};

export const configUkmetLayerIsotachMesh = {
  "Name" : "Isotach",
  "Renderer" : "Mesh",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "fill_type" : "flat",
        "palette_gradient": false,
        "palette_step": 1,
        "palette" : [
          {
            "value" : 100.0,
            "color" : "rgba(144, 238, 144, 0.5)"
          },
          {
            "value" : 160.0,
            "color" : "rgba(244, 150, 44, 0.2)"
          },
          {
            "value" : 300.0,
            "color" : "rgba(244, 150, 44, 0.2)"
          }
        ]
      }
    }
  }
}

export const configUkmetLayerIsotherm = {
  "Name" : "GPVTmpContourSample",
  "Renderer": "Contour",
  "Attributes": {
    "data_offset": -273.15,
    "data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": -200,
            "interval": 5.0,
            "num": 27,
            "strokeStyle": "rgba(251, 0, 6, 1)",
            "textColor": "rgba(107,0,2,1)",
          },
          {
            "base": -68,
            "interval": 0,
            "num": 1,
            "strokeStyle": "rgba(251, 0, 6,1)",
            "textColor": "rgba(107,0,2,1)",
          },
          {
            "base":-67,
            "interval":1,
            "num": 3,
            "lineWidth": 1,
            "strokeStyle": "rgb(220,175,7)",
            "textColor": "rgba(107,0,2,1)",
            "fontSize": 14
          },
          {
            "base":-64,
            "interval":5,
            "num": 23,
            "lineWidth": 1,
            "strokeStyle": "rgba(107,0,2,1)",
            "textColor": "rgba(107,0,2,1)",
            "fontSize": 14
          }
        ]
      }
    }
  }
}

export const configUkmetLayerIsothermMesh = {
  "Name": "GPVTmpFillSample",
  "Renderer": "Mesh",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "fill_type" : "flat",
        "palette_gradient": false,
        "palette_step": 1,
        "palette" : [
          {
            "value" : -200,
            "color" : "rgba(251, 0, 6, 0.2)"
          },
          {
            "value" : -68,
            "color" : "rgba(255, 255, 11, 0.2)"
          },
          {
            "value" : -65,
            "color" : "rgba(0, 0, 0, 0)"
          }
        ]
      }
    }
  }
}

export const configUkmetLayerIsothermGrid = {
  "Name": "GPVTempGridValue",
  "Renderer": "GridValueExt",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(0, 0, 0, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      },
      "dark": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(255, 255, 255, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      }
    }
  }
};

export const configUkmetLayerGeoPotentialHeight = {
  "Name": "GeoPotentialHeight",
  "Renderer": "Contour",
  "Attributes": {
    "data_offset": 0,
    "style_selector": {
      "key": "level",
      "styles": [
        {
          "values": ["1000", "975", "950", "925", "900", "850", "800", "750", "700", "600", "500"],
          "style": "low"
        },
        {
          "values": ["450", "400", "350", "300", "275", "250", "225", "200", "175", "150", "125", "100"],
          "style": "high"
        }
      ]
    },
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 60,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(20,95,20)"
          }
        ]
      },
      "low": {
        "contour": [
          {
            "base": 0,
            "interval": 60,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(20,95,20)"
          }
        ]
      },
      "high": {
        "contour": [
          {
            "base": 4200,
            "interval": 120,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(20,95,20)"
          }
        ]
      }
    }
  }
};

export const configUkmetLayerIcingProb = {
  "Name": "IcingProbavility",
  "Renderer": "GridIcon",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "✱",
            "text_color": "#000000"
          }
        ]
      },
      "dark": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "＊",
            "text_color": "#c4c2c2"
          }
        ]
      }
    }
  }
};